export default __webpack_public_path__ + "static/nfpa_w.8fb9552d290314858af0b412787a0b6c.svg";